import React from 'react';
import '../../App.css';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/common/Sidebar';
import DashboardWidgets from './DashboardWidgets';
import EventsWidgets from '../Event/EventsWidgets';
import EventCreation from '../Event/EventCreation';
import LeadsWidgets from '../Lead/LeadsWidgets';
import LeadsPageLayout from '../Lead/LeadsPageLayout';
import LeadGroupsPage from '../Lead/LeadGroupsPage';
import Automation from '../Automation/Automation';
import Template from '../Template/Template';
import EmailSetup from '../Email/EmailSetup';
import EmailCenter from '../Email/EmailCenter';
import WhatsApp from '../WhatsApp/WhatsApp';
import UserSessionManager from '../../utils/UserSessionManager';
import VideoConference from '../VideoConference/VideoConference';
import AccountsPageLayout from '../Accounts/AccountsPageLayout';
import AccountsWidgets from '../Accounts/AccountsWidgets';
import CalendarPage from '../Calendar/CalendarPage';
import FeatureFlags from '../Features/FeatureFlags';

const AdminDashboard = () => {
  const userInfo = UserSessionManager.getUserInfo();
  const navigate = useNavigate();

  const handleRenewPlan = () => {
    navigate('/products');
  };

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      
      {/* Welcome message at top */}
      <div className="d-flex justify-content-between align-items-center px-4 py-2">
        <h4 className="mb-0">🎉 Welcome {userInfo.fullName}!</h4>
        <div className="d-flex align-items-center gap-3">
          <div className="subscription-info">
            {
              userInfo.activationPlan ? (
                <>
                  Enrolled In: <strong>{userInfo.activationPlan}</strong>, Subscription expires on{" "}
                  <span className="text-success fw-bold">
                    {new Date(userInfo.subscriptionEndDate).toLocaleDateString('en-GB', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                    })}
                  </span>
                </>
              ) : (
                'No active subscription plan'
              )
            }
          </div>
          {userInfo.showRenewal && (
            <button 
              className="btn btn-primary" 
              onClick={handleRenewPlan}
              style={{ whiteSpace: 'nowrap',backgroundColor: '#d07c3e' }}
            >
              Renew
            </button>
          )}
        </div>
      </div>

      {/* Layout starts here */}
      <div className="d-flex">
        <Sidebar />
        <div className="px-4 py-0 flex-grow-1 min-w-0">
          <Routes>
            <Route
              path="/"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Dashboard</div>
                  <div className="dashboard-card">
                    <DashboardWidgets />
                  </div>
                </div>
              }
            />
            <Route
              path="/dashboard"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Dashboard</div>
                  <div className="dashboard-card">
                    <DashboardWidgets />
                  </div>
                </div>
              }
            />
            <Route
              path="/events"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Events</div>
                  <div className="dashboard-card">
                    <EventsWidgets />
                  </div>
                </div>
              }
            />
            <Route
              path="/create-events"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Create Events</div>
                  <div className="dashboard-card">
                    <EventCreation />
                  </div>
                </div>
              }
            />
            <Route
              path="/create-events/:eventId?"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Create Events</div>
                  <div className="dashboard-card">
                    <EventCreation />
                  </div>
                </div>
              }
            />
            <Route
              path="/leads/*"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Leads</div>
                  <div className="dashboard-card">
                    <LeadsPageLayout />
                  </div>
                </div>
              }
            >
              <Route
                index
                element={<LeadsWidgets onStatusChange={() => {}} onLeadUpdate={() => {}} />}
              />
              <Route path="groups" element={<LeadGroupsPage />} />
            </Route>
            <Route
              path="/accounts"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Accounts</div>
                  <div className="dashboard-card">
                    <AccountsPageLayout>
                      <AccountsWidgets />
                    </AccountsPageLayout>
                  </div>
                </div>
              }
            />
            <Route
              path="/automation"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Automation</div>
                  <div className="dashboard-card">
                    <Automation />
                  </div>
                </div>
              }
            />
            <Route
              path="/templates"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Templates</div>
                  <div className="dashboard-card">
                    <Template />
                  </div>
                </div>
              }
            />
            <Route
              path="/email"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Email</div>
                  <div className="dashboard-card">
                    <EmailSetup />
                  </div>
                </div>
              }
            />
            <Route
              path="/email-v2"
              element={<EmailCenter />}
            />
            <Route
              path="/whatsapp"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">WhatsApp</div>
                  <div className="dashboard-card">
                    <WhatsApp />
                  </div>
                </div>
              }
            />
            <Route
              path="/video-conf"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Video Conference</div>
                  <div className="dashboard-card">
                    <VideoConference />
                  </div>
                </div>
              }
            />
            <Route
              path="/calendar"
              element={
                <div className="dashboard-wrapper">
                  <div className="page-header-tab">Calendar</div>
                  <div className="dashboard-card">
                    <CalendarPage />
                  </div>
                </div>
              }
            />
            <Route
              path="/features"
              element={<FeatureFlags />}
            />

          </Routes>
        </div>
      </div>

    </div>
  );
};

export default AdminDashboard;
